/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class Info extends React.Component {
  render() {
    return <div>
      {this.props.children}
    </div>
  }
};
export default Info;


// WEBPACK FOOTER //
// ./src/routes/info/index.js